import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            w: 24,
            h: 2,
            x: 0,
            y: 0,
            i: 'c6',
            static: true,
        },
        {
            w: 10,
            h: 8,
            x: 0,
            y: 2,
            i: 'c7',
            static: true,
        },
        {
            w: 8,
            h: 8,
            x: 10,
            y: 2,
            i: 'c2',
            static: true,
        },
        {
            w: 6,
            h: 8,
            x: 18,
            y: 2,
            i: 'c3',
            static: true,
        },
        {
            w: 16,
            h: 8,
            x: 0,
            y: 10,
            i: 'c4',
            static: true,
        },
        {
            w: 8,
            h: 8,
            x: 16,
            y: 10,
            i: 'c5',
            static: true,
        },
    ],
    md: [
        {
            h: 8,
            static: true,
            w: 8,
            x: 10,
            y: 2,
            i: 'c2',
        },
        {
            h: 8,
            static: true,
            w: 6,
            x: 18,
            y: 2,
            i: 'c3',
        },
        {
            h: 8,
            static: true,
            w: 16,
            x: 0,
            y: 10,
            i: 'c4',
        },
        {
            h: 8,
            static: true,
            w: 8,
            x: 16,
            y: 10,
            i: 'c5',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c6',
        },
        {
            h: 8,
            static: true,
            w: 10,
            x: 0,
            y: 2,
            i: 'c7',
        },
    ],
    xs: [
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 14,
            i: 'c2',
        },
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 22,
            i: 'c3',
        },
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 38,
            i: 'c4',
        },
        {
            h: 8,
            static: true,
            w: 24,
            x: 0,
            y: 30,
            i: 'c5',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c6',
        },
        {
            h: 12,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c7',
        },
    ],
};

export const pageConfig: PageConfig = {
    pageProps: {
        user_asset_class_records: 9,
        user_industry_records: 9,
        contract_currency_records: 9,
        user_geography_records: 9,
        custodian_name_records: 9,
        date: 'today',
    },
    components: [
        {
            name: 'page-header',
            key: 'c6',
            props: {
                header: {
                    title: 'asset-allocation',
                    path: '/portfolio/allocations',
                },
                rhsComponents: [
                    {
                        name: 'date-picker',
                    },
                ],
            },
        },
        {
            name: 'chart-data-table',
            key: 'c7',
            apiDetails: {
                endpoint: `portfolio/allocations?group_by=user_asset_class&`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                    number_of_top_records: 'user_asset_class_records',
                },
            },
            props: {
                group_by: 'user_asset_class',
                records: 10,
                header: 'asset-class',
                drillDownPagePath: 'portfolio/allocations/group',
                numberOfRowsPerPage: 5,
                chartType: 'donut',
            },
        },
        {
            name: 'chart-data-table',
            key: 'c2',
            apiDetails: {
                endpoint: `portfolio/allocations?group_by=user_industry&`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                    number_of_top_records: 'user_industry_records',
                },
            },
            props: {
                group_by: 'user_industry',
                header: 'sub-asset-class',
                drillDownPagePath: 'portfolio/allocations/group',
            },
        },
        {
            name: 'chart-data-table',
            key: 'c3',
            apiDetails: {
                endpoint: `portfolio/allocations?group_by=contract_currency&`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                    number_of_top_records: 'contract_currency_records',
                },
            },
            props: {
                group_by: 'contract_currency',
                header: 'currency',
                drillDownPagePath: 'portfolio/allocations/group',
            },
        },
        {
            name: 'chart-data-table',
            key: 'c4',
            apiDetails: {
                endpoint: `portfolio/allocations?group_by=user_geography&`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                    number_of_top_records: 'user_geography_records',
                },
            },
            props: {
                group_by: 'user_geography',
                chartType: 'map',
                header: 'geography',
                drillDownPagePath: 'portfolio/allocations/group',
            },
        },
        {
            name: 'chart-data-table',
            key: 'c5',
            apiDetails: {
                endpoint: `portfolio/allocations?group_by=custodian_name&`,
                endpointParams: {
                    to_date: '*,date',
                    parent_user_ids: '*,user_id',
                    number_of_top_records: 'custodian_name_records',
                },
            },
            props: {
                group_by: 'custodian_name',
                header: 'custodian',
                drillDownPagePath: 'portfolio/allocations/group',
            },
        },
    ],
};
